import React from 'react';
import SectionBundleReceiptEntry from '../SectionBundleReceiptEntry';

const WeavingBundleReceiptEntry = () => (
  <SectionBundleReceiptEntry
    sectionName="Weaving Section"
    sectionDisplayName="Weaving Section"
    backRoute="/sections/weaving"
  />
);

export default WeavingBundleReceiptEntry;
